import { teamsTheme, teamsDarkTheme, teamsHighContrastTheme } from '@fluentui/react-northstar'


export function getMicrosoftTeamsTheme(theme) {
  // console.log(`getMicrosoftTeamsTheme with theme : \n${theme ? JSON.stringify(theme, null, 2) : 'UNDEFINED'}`);
  let msTeamsTheme = teamsTheme;

  if (theme) {
    switch (theme) {
      case "dark":
        msTeamsTheme = teamsDarkTheme;
        break;
      case "contrast":
        msTeamsTheme = teamsHighContrastTheme;
        break;
      default:
        msTeamsTheme = teamsTheme;
        break;
    }
  }

  return msTeamsTheme;
}
